/**
 * Example Vue widgets
 *
 * Mount all widgets via the root index.js file.
 */

import 'protons';

// Module template
import './_vue-repayment-calculator.twig';
import './_vue-save-calculator.twig';
import './_vue-extra-payment-calculator.twig';

// Module styles
import './_vue-widget.scss';

// All Vue widgets only execute on existence of DOM
import VueRepaymentCalculator from './src/vue-calculator/repayment-calculator';
import VuePurchaseCalculator from './src/vue-calculator/purchase-calculator';
import VueLTVCalculator from './src/vue-calculator/ltv-calculator';
import VueAffordabilityCalculator from './src/vue-calculator/affordability-calculator';
import VueRefinanceCalculator from './src/vue-calculator/refinance-calculator';
import SaveCalc from './src/vue-calculator/save-calculator';
import ExtraPaymentCalc from './src/vue-calculator/extra-payment-calculator';

// Render Vue elements as soon as possible
// Affordability calculator
if (document.getElementById('vue-affordability-calculator')) {
  VueAffordabilityCalculator('#vue-affordability-calculator');
}
// Repayment calculator
if (document.getElementById('vue-repayment-calculator')) {
  VueRepaymentCalculator('#vue-repayment-calculator');
}
// Mortgage calculator
if (document.getElementById('vue-purchase-calculator')) {
  VuePurchaseCalculator('#vue-purchase-calculator');
}
// Refinance calculator
if (document.getElementById('vue-refinance-calculator')) {
  VueRefinanceCalculator('#vue-refinance-calculator');
}

// Ltv calculator
if (document.getElementById('vue-ltv-calculator')) {
  VueLTVCalculator('#vue-ltv-calculator');
}

// Save calculator
if (document.getElementById('save-calculator')) {
  SaveCalc('#save-calculator');
}

// Extra Payment Calculator.
if (document.getElementById('extra-payment-calculator')) {
  ExtraPaymentCalc('#extra-payment-calculator');
}

export const name = 'vue-widget';

export function disable() {}

export function enable() {
  // Send data from settings or post-docready() work here, e.g
  // FacetTableVueX.$store.dispatch('exampleAction', settings.vueExampleData');
}

export default enable;
